import React, { useState } from "react";
import Box from "@mui/material/Box";
import useInputKeys from "hooks/useInputKeys";
import BackButtonImage from "assets/images/backButton.png";
import guessNumberGameEn from "assets/images/guess_number_game_en.png";
import guessNumberGameFa from "assets/images/guess_number_game_fa.png";
import GuessNumber from "components/TimelinePageOne/Screen/GameBox/games/GuessNumber";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "./index.scss";

function GameBox({ handleClose }) {
  const { t } = useTranslation();
  const { direction } = useInputKeys();

  const games = [
    {
      banner:
        direction === "ltr" || direction === null || direction === ""
          ? guessNumberGameEn
          : guessNumberGameFa,
      details: t("guessNumberDetails"),
      title: t("guessNumber"),
      id: 1,
      component: (handleBack) => (
        <GuessNumber
          handleBack={handleBack}
          setSelectedGame={setSelectedGame}
        />
      ),
    },
  ];

  const [selectedGame, setSelectedGame] = useState(null);

  return (
    <Box className="game-box-component">
      {!selectedGame ? (
        <Box className="select-game-box">
          <Box className="button-box">
            <Box className="back-button" onClick={handleClose}>
              <img
                src={BackButtonImage}
                alt="Back Button"
                className={direction}
              />
              <span>{t("games")}</span>
            </Box>
          </Box>
          <Box className="swiper-wrapper">
            <Swiper className="games-carousel" slidesPerView={1} centeredSlides>
              {games.map((game) => (
                <SwiperSlide
                  key={game.id}
                  className="carousel-item"
                  onClick={() => setSelectedGame(game)}
                >
                  <img src={game.banner} alt={game.title} />
                  <div className={direction}>{t(game.details)}</div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </Box>
      ) : (
        <Box className="game-box">
          {selectedGame.component(setSelectedGame)}
        </Box>
      )}
    </Box>
  );
}

export default GameBox;
